
export default function UsersUsuarios(){

    return(
        <>
            <h1>Usuarios disponibles!</h1>
        </>
    )
}